<template>
    <!-- 休闲娱乐 2  -->
    <sub-page :title="title" :subtitle="subtitle" :description="description" :button-text="buttonText" :bg="bg"
        :right-bg="rightBg" :right-bg2="rightBg2" bottom="0" :rbgStyle="{
            width: '70%',
            padding: 0
        }" :rbg2Style="{
            width: '30%',
            padding: 0,
            position: 'absolute',
            right: '70px',
            bottom: '-30px'
        }" />
</template>

<script>
import SubPage from '@/views/components/SubPage.vue'
export default {
    name: 'entertainment-two',
    components: {
        SubPage
    },
    data() {
        return {
            bg: "/img/pay/0-_BG-3.png",
            rightBg: "/img/pay/0--73.png",
            rightBg2: "/img/pay/0--72.png",
        }
    },
    computed: {
        title() {
            return this.$t('entertainment.title');
        },
        subtitle() {
            return this.$t('entertainmentTwo.subtitle');
        },
        description() {
            const desc = this.$t('entertainmentTwo.description');
            return Array.isArray(desc) ? desc : [desc];
        },
        buttonText() {
            return this.$t('common.buttonText');
        },
    }
}
</script>